// require('./web_socket.js');

const rawHeaderLen = 16;
const packetOffset = 0;
const headerOffset = 4;
const verOffset = 6;
const opOffset = 8;
const seqOffset = 12;

function mergeArrayBuffer(ab1, ab2) {
    var u81 = new Uint8Array(ab1),
        u82 = new Uint8Array(ab2),
        res = new Uint8Array(ab1.byteLength + ab2.byteLength);
    res.set(u81, 0);
    res.set(u82, ab1.byteLength);
    return res.buffer;
}

function char2ab(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i=0; i<str.length; i++) {
        bufView[i] = str[i];
    }
    return buf;
}

var WsClient = function(url, options) {
    this.is_reconnet = true;
    var MAX_CONNECT_TIMES = 30;
    var DELAY = 5000;
    this.url = url;
    this.options = options || {};
    this.ws = null;
    this.createConnect(MAX_CONNECT_TIMES, DELAY);
}

WsClient.prototype.close = function() {
    this.is_reconnet = false;
    if (this.ws) {
        this.ws.close();
    }
}

WsClient.prototype.createConnect = function(max, delay) {
    var self = this;
    if (max === 0) {
        return;
    }
    connect();

    var textDecoder = new TextDecoder();
    var textEncoder = new TextEncoder();
    var heartbeatInterval;
    function connect() {
        self.is_reconnet = true;
        self.ws = new WebSocket(self.url);
        self.ws.binaryType = 'arraybuffer';
        self.ws.onopen = function() {
            auth();
        }

        self.ws.onmessage = function(evt) {
            var data = evt.data;
            var dataView = new DataView(data, 0);
            var packetLen = dataView.getInt32(packetOffset);
            var headerLen = dataView.getInt16(headerOffset);
            var ver = dataView.getInt16(verOffset);
            var op = dataView.getInt32(opOffset);
            var seq = dataView.getInt32(seqOffset);
            console.log('接受到的数据',data)
            console.log("接受的头 receiveHeader: packetLen=" + packetLen, "headerLen=" + headerLen, "ver=" + ver, "op=" + op, "seq=" + seq);
            console.log('接受到的状态值',op)
            var onmessage = self.options.onmessage;
            if (typeof onmessage != 'function') {
              onmessage = function(){}
            }
            /**
            Protocol:
              Package Length	   4 bytes	header + body length
              Header Length	     2 bytes	protocol header length
              Protocol Version	 2 bytes	protocol version
              Operation	         4 bytes	operation for request
              Sequence id	       4 bytes	sequence number chosen by client
              Body	         PackLen + HeaderLen	binary body bytes
            Operation:
              OpHandshake       = 0	握手
              OpHandshakeReply  = 1	握手回复
              OpHeartbeat       = 2	心跳
              OpHeartbeatReply  = 3	心跳回复
              OpSendMsg         = 4	发信息
              OpSendMsgReply    = 5	发送信息回复
              OpDisconnectReply = 6	连接断开回复
              OpAuth            = 7	认证连接
              OpAuthReply       = 8	验证连接回复
              OpRawBatch        = 9	Websocket的批处理消息
            **/
            switch(op) {
                case 8:
                    // send a heartbeat to server
                    heartbeat();
                    heartbeatInterval = setInterval(heartbeat, 30 * 1000);
                    break;

                case 3:
                    // receive a heartbeat from server
                    console.log("接受心跳receive: heartbeat");
                    break;
                case 9:
                    for (var offset=rawHeaderLen; offset<data.byteLength; offset+=packetLen) {
                        // parse
                        var npacketLen = dataView.getInt32(offset);
                        var nheaderLen = dataView.getInt16(offset+headerOffset);
                        var nver = dataView.getInt16(offset+verOffset);
                        var nop = dataView.getInt32(offset+opOffset);
                        var nseq = dataView.getInt32(offset+seqOffset);
                        var nbody = textDecoder.decode(data.slice(offset+headerLen, offset+packetLen));
                        let msg = "状态9的消息 receive: ver=" + ver + " op=" + op + " seq=" + seq + " message=" + nbody
                        console.log('-------------', msg)
                        // callback
                        onmessage.call(self.ws, {
                          dataView,
                          packetLen,
                          headerLen,
                          ver,
                          op,
                          seq,
                        }, {
                          npacketLen,
                          nheaderLen,
                          nver,
                          nop,
                          nseq,
                          nbody,
                        });
                    }
                    return;
                    break;
                default:
                    break
            }

            onmessage.call(self.ws, {
              dataView,
              packetLen,
              headerLen,
              ver,
              op,
              seq,
            });
        }

        self.ws.onclose = function() {
            if (heartbeatInterval) clearInterval(heartbeatInterval);
            if (self.is_reconnet) {
                setTimeout(reConnect, delay);
            }

            var onclose = self.options.onclose;
            if (typeof onclose != 'function') {
                onclose = function(){}
            }

            onclose.call(self.ws)
        }

        function heartbeat() {
            var headerBuf = new ArrayBuffer(rawHeaderLen);
            var headerView = new DataView(headerBuf, 0);
            headerView.setInt32(packetOffset, rawHeaderLen);
            headerView.setInt16(headerOffset, rawHeaderLen);
            headerView.setInt16(verOffset, 1);
            headerView.setInt32(opOffset, 2);
            headerView.setInt32(seqOffset, 1);
            self.ws.send(headerBuf);
            console.log("send: heartbeat");
        }

        function auth() {
            var token = self.options.token || '{}';
            var headerBuf = new ArrayBuffer(rawHeaderLen);
            var headerView = new DataView(headerBuf, 0);
            var bodyBuf = textEncoder.encode(token);
            headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
            headerView.setInt16(headerOffset, rawHeaderLen);
            headerView.setInt16(verOffset, 1);
            headerView.setInt32(opOffset, 7);
            headerView.setInt32(seqOffset, 1);
            self.ws.send(mergeArrayBuffer(headerBuf, bodyBuf));
        }
    }

    function reConnect() {
        if (self.ws) self.createConnect(--max, delay * 2);
    }
}


export default WsClient;
